import styled, { css } from 'styled-components'

import rem from '../../../../styles/tools/rem'
import em from '../../../../styles/tools/em'

import { txt16OpenSans, title28GalanoBold, title16Galano } from '../../../../styles/settings/types'

import {
  darkSlateBlue,
  red,
  deliveredGreen,
  organicSilver,
  white
} from '../../../../styles/settings/colors'

export const SearchIconContainer = styled.div`
  position: absolute;
  left: 15px;
  top: 20px;
`

export const CloseIconContainer = styled.div`
  position: absolute;
  right: 15px;
  top: 20px;
`

export const SearchInput = styled.input`
  border: none;
  border-bottom: 3px solid ${darkSlateBlue};
  ${({ plateIsValid }) => plateIsValid && `border-bottom: 3px solid ${deliveredGreen}`};
  ${({ invalidInput }) => invalidInput && `border-bottom: 3px solid ${red}`};
  background-color: rgba(226, 225, 235, 0.16);
  padding: ${rem('16px')} ${rem('16px')} ${rem('16px')} ${rem('50px')};
  line-height: ${rem('24px')};
  color: ${darkSlateBlue};
  ${txt16OpenSans};
  width: 100%;
`

export const Loading = styled.img`
  width: ${rem('25px')};
  position: absolute;
  right: ${rem('5px')};
  top: ${rem('16px')};
`

export const LoadingTable = styled.img`
  width: ${rem('45px')};
`

export const Error = styled.span`
  color: ${red};
  display: inline-block;
  font-family: OpenSans;
  font-size: ${rem('14px')};
  letter-spacing: ${rem('-0.3px')};
`

export const SearchInputWrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  ${({ hide }) => hide && `display: none`};
`

export const Container = styled.section`
  width: 100%;
  padding: ${rem('9px')} 0 ${rem('17px')};
  background-color: white;
  display: flex;
  justify-content: center;
`

export const Content = styled.div`
  display: flex;
  justify-content: flex-start;
  ${({ isLoadingPagination }) => isLoadingPagination && `align-items: center;`};
  flex-direction: column;
  width: ${rem('960px')};
`

export const Title = styled.h1`
  letter-spacing: ${em('0.4px')};
  color: ${darkSlateBlue};
  margin-top: ${rem('25px')};
  margin-bottom: ${rem('30px')};
  ${title28GalanoBold};
  letter-spacing: normal;
  line-height: 1;
`

export const InputContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 32px;
`

export const FilterTypes = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  height: auto;
  padding: 0;
  width: 100%;
  overflow: visible;
  flex-wrap: wrap;
  justify-content: flex-start;
`

export const IdentifierLabel = styled.label`
  position: relative;
  color: ${darkSlateBlue};
  ${title16Galano};
  padding: ${rem('10px')} ${rem('15px')};
  height: 100%;
  width: 100%;
  text-align: center;
  line-height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ isSelected }) => isSelected && `background: #aeabc4; border-radius: ${rem('8px')};`};
  ${({ isSelected, isBlockedEdit }) =>
    !isSelected &&
    isBlockedEdit &&
    `background: #aeabc4; border-radius: ${rem('8px')}; opacity: 0.4;`};
`

export const InputIdentifier = styled.input.attrs({
  type: 'checkbox'
})`
  opacity: 0;
  display: block;
  z-index: 1;
  position: absolute;
  width: 100%;
  height: 100%;
`

export const ListItem = styled.li`
  height: ${rem('56px')};
  margin: ${rem('10px')} ${rem('10px')};
  width: ${rem('140px')};
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08), 0px 0px 1px rgba(0, 0, 0, 0.12);
  border-radius: ${rem('8px')};
`

export const IdentifierItemContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
`

export const Page = styled.li`
  margin: 0 ${rem('15px')};
  ${title16Galano};
  color: ${({ isCurrentPage }) => (isCurrentPage ? darkSlateBlue : organicSilver)};
  cursor: pointer;
  &:hover {
    color: ${darkSlateBlue};
  }
`
export const PageList = styled.ul`
  list-style: none;
  display: flex;
  padding: 0;
  margin-top: ${rem('12px')};
`

export const PaginatorContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: ${rem('40px')};
  div {
    display: flex;
    align-items: center;
  }
`

export const SearchContainer = styled.div``

export const FilterContainer = styled.div`
  display: flex;
  justify-content: flex-end;

  margin-bottom: 64px;

  button:last-child {
    margin-left: 24px;
  }
`

export const SaveFilterSelection = styled.button`
  ${title16Galano};
  line-height: 20.8px;
  color: ${({ secondary }) => (secondary ? darkSlateBlue : white)};

  background-color: ${({ secondary }) => (secondary ? white : darkSlateBlue)};
  padding: 16px 32px;
  min-width: 116px;
  height: 52px;

  border: none;
  border-radius: 28px;
  ${({ secondary }) =>
    secondary &&
    css`
      border: 2px solid ${darkSlateBlue};
    `};
  cursor: pointer;

  svg {
    margin-left: 8px;
  }
`



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatement/FilterByIdentifier/styles.js